/**
 * bmm-collection-page.js  v1.0
 * Clothio — Collection Page Scripts
 *
 * Scope: Collection Switcher scroll behaviour ONLY.
 * Vanilla JS. No jQuery. No global state.
 * Deferred via <script defer> — DOM is ready when this executes.
 *
 * Supports multiple switcher instances on the same page
 * (Shopify renders multiple section.id values).
 */

(function () {
  'use strict';

  const SCROLL_AMT = 220; // px per arrow click

  /**
   * Initialise one collection switcher instance.
   * @param {HTMLElement} section — the .bmm-cs root element
   */
  function initSwitcher(section) {
    const sectionId = section.dataset.sectionId;
    if (!sectionId) return;

    const track = document.getElementById('bmm-cs-track-' + sectionId);
    const prev  = document.getElementById('bmm-cs-prev-' + sectionId);
    const next  = document.getElementById('bmm-cs-next-' + sectionId);

    if (!track) return;

    // ── Arrow scroll ──
    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -SCROLL_AMT, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: SCROLL_AMT, behavior: 'smooth' });
      });
    }

    // ── Scroll active tab into center on load ──
    var activeTab = track.querySelector('.bmm-cs__tab.is-active');
    if (activeTab) {
      // setTimeout 120ms: waits for browser layout pass before scrollIntoView
      // Without this, scroll position is calculated before fonts/images paint
      setTimeout(function () {
        activeTab.scrollIntoView({
          inline: 'center',
          behavior: 'smooth',
          block: 'nearest',
        });
      }, 120);
    }

    // ── Arrow visibility: hide when scrolled to start/end ──
    // Uses IntersectionObserver on first and last tabs
    updateArrowVisibility(track, prev, next);
    track.addEventListener('scroll', debounce(function () {
      updateArrowVisibility(track, prev, next);
    }, 80), { passive: true });
  }

  /**
   * Show/hide arrows based on scroll position.
   */
  function updateArrowVisibility(track, prev, next) {
    if (!prev && !next) return;
    var scrollLeft = track.scrollLeft;
    var maxScroll  = track.scrollWidth - track.clientWidth;

    if (prev) {
      prev.style.opacity = scrollLeft <= 4 ? '0.3' : '1';
      prev.style.pointerEvents = scrollLeft <= 4 ? 'none' : '';
    }
    if (next) {
      next.style.opacity = scrollLeft >= maxScroll - 4 ? '0.3' : '1';
      next.style.pointerEvents = scrollLeft >= maxScroll - 4 ? 'none' : '';
    }
  }

  /**
   * Simple debounce utility.
   */
  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  // ── Boot: find all switcher instances ──
  var switchers = document.querySelectorAll('.bmm-cs[data-section-id]');
  switchers.forEach(initSwitcher);

  // ── Theme editor: re-init on section load/re-render ──
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.bmm-cs[data-section-id]');
      if (section) initSwitcher(section);
    });
  }

})();
